var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "modal-mask",
        class: { "modal-open": _vm.show }
      },
      [
        _vm.disableClickOut
          ? _c(
              "div",
              {
                staticClass: "modal fade",
                class: { in: _vm.show },
                style: _vm.openStyles,
                attrs: { tabindex: "-1", role: "dialog" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    class: "modal-dialog " + _vm.modalDialogSize,
                    attrs: { role: "document" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "modal-content",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "modal-header" },
                          [
                            _vm._t(
                              "header",
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "close",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "Close"
                                    },
                                    on: { click: _vm.close }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v("×")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("h4", { staticClass: "modal-title" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.modalTitle) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ])
                              ],
                              { close: _vm.close }
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal-body" },
                          [
                            _vm._t("hint"),
                            _vm._v(" "),
                            _vm._t("default", null, {
                              close: _vm.close,
                              fields: _vm.fields
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal-footer" },
                          [
                            _vm._t(
                              "footer",
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    attrs: { type: "button" },
                                    on: { click: _vm.close }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.closeText) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              { close: _vm.close }
                            )
                          ],
                          2
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          : _c(
              "div",
              {
                staticClass: "modal fade",
                class: { in: _vm.show },
                style: _vm.openStyles,
                attrs: { tabindex: "-1", role: "dialog" },
                on: { click: _vm.close }
              },
              [
                _c(
                  "div",
                  {
                    class: "modal-dialog " + _vm.modalDialogSize,
                    attrs: { role: "document" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "modal-content",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "modal-header" },
                          [
                            _vm._t(
                              "header",
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "close",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "Close"
                                    },
                                    on: { click: _vm.close }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v("×")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("h4", { staticClass: "modal-title" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.modalTitle) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ])
                              ],
                              { close: _vm.close }
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal-body" },
                          [
                            _vm._t("hint"),
                            _vm._v(" "),
                            _vm._t("default", null, {
                              close: _vm.close,
                              fields: _vm.fields
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal-footer" },
                          [
                            _vm._t(
                              "footer",
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    attrs: { type: "button" },
                                    on: { click: _vm.close }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.closeText) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              { close: _vm.close }
                            )
                          ],
                          2
                        )
                      ]
                    )
                  ]
                )
              ]
            )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }